import styles from './Feedback.module.scss'
import { ContactEmailInput, ContactSwitch, HelpText, SuggestionCheckbox } from './FeedbackSections'
import ProductSuggestion from './ProductSuggestion'

import React, { useState } from 'react'

import Button from 'Molecules/Button'

import Form from 'Atoms/Form'
import Typography from 'Atoms/Typography'

const GeneralFeedback = ({
  handleSubmit,
  contactOkay,
  setContactOkay,
  email,
  onEmailChange,
  EMAILINPUTID,
  isPositive,
  name,
  generalFeedbackPrompt,
  searchProvider,
  hideProductSuggestion,
}) => {
  const [text, setText] = useState('')
  const onChange = (e) => {
    setText(e.target.value)
  }
  const [showProductSuggestion, setShowProductSuggestion] = useState(false)

  const qualifier = isPositive ? 'Positive' : 'Negative'

  const segmentEvent = {
    event: 'Feedback Submitted',
    properties: {
      emotion: qualifier.toLowerCase(),
      feedback: text,
      element: name,
      okay_to_contact: contactOkay,
      entered_email: email,
      feedbackURL:
        `customer=${encodeURIComponent(email)}` +
        `&message=${encodeURIComponent(text)}` +
        `&type=${encodeURIComponent(name)}` +
        `&emotion=${encodeURIComponent(qualifier.toLowerCase())}`,
    },
  }
  if (searchProvider) segmentEvent.properties.search_provider = searchProvider

  const productSuggestionIsNotShown = !showProductSuggestion || hideProductSuggestion

  return (
    <Form className={styles.container} onSubmit={handleSubmit}>
      <Form.TextArea
        autoFocus
        className={styles.textArea}
        rows={6}
        fill
        label={generalFeedbackPrompt}
        onChange={onChange}
        placeholder="Share your ideas for making the website better..."
      />

      <ContactSwitch contactOkay={contactOkay} setContactOkay={setContactOkay} />

      {contactOkay && <ContactEmailInput email={email} onEmailChange={onEmailChange} id={EMAILINPUTID} />}

      {!hideProductSuggestion && (
        <SuggestionCheckbox
          show={showProductSuggestion}
          toggle={() => setShowProductSuggestion((prev) => !prev)}
          label={
            <Typography as={'h3'} font={'bold'}>
              Suggest a product or part number
            </Typography>
          }
        />
      )}

      {productSuggestionIsNotShown && (
        <Button
          className={styles.submitButton}
          segmentEvent={segmentEvent}
          brand={'secondary'}
          size={'small'}
          text={'Send Feedback'}
          data-testid={`${name}DescriptiveFeedback-${qualifier}`}
          type={'submit'}
          disabled={!text || (contactOkay && !email)}
        />
      )}

      {productSuggestionIsNotShown && <HelpText />}

      {!productSuggestionIsNotShown && (
        <ProductSuggestion
          contactOkay={contactOkay}
          setContactOkay={setContactOkay}
          email={email}
          onEmailChange={onEmailChange}
          EMAILINPUTID={EMAILINPUTID}
          isPositive={isPositive}
          name={name}
          generalFeedbackPrompt={generalFeedbackPrompt}
          searchProvider={searchProvider}
          generalFeedbackSegmentEvent={segmentEvent}
          generalFeedbackText={text}
        />
      )}
    </Form>
  )
}

export default GeneralFeedback
